import { createSlice } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    report: null,
};

export const TeachersByCycle = createSlice({
    name: "TeachersByCycle",
    initialState,
    reducers: {
        setReport: (state, action) => {
            state.report = action.payload;
        },
        clearReport: (state) => {
            state.report = initialState.report;
        },
    },
});

export const { setReport, clearReport } = TeachersByCycle.actions;

export default TeachersByCycle.reducer;

export const startShowReport = ({ cycles, coordination_id, type }) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const cycles_data = `${cycles.year}-${cycles.sub_cycle}`;

        const params = new URLSearchParams();

        params.set("cycles", cycles_data);
        if (coordination_id) {
            params.set("coordination_id", coordination_id);
        }
        if (type) {
            params.set("type", type);
        }

        const resp = await Call(
            `operators/reports/teachers/by/cycle`,
            "GET",
            params
        );

        if (resp.success) {
            dispatch(setReport(resp.success));
        } else {
            errorHandler(resp);
        }
        dispatch(stopUILoading());
    };
};

export const startExportReport = ({ cycles, type, coordination_id }) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const cycles_data = `${cycles.year}-${cycles.sub_cycle}`;

        const params = new URLSearchParams();

        params.set("export", 1);
        params.set("cycles", cycles_data);
        if (coordination_id) {
            params.set("coordination_id", coordination_id);
        }
        if (type) {
            params.set("type", type);
        }

        const response = await CallWithFormDataFile(
            `operators/reports/teachers/by/cycle`,
            "GET",
            params.toString()
        );
        downloadBlob(response, `Reporte de docentes por ciclo`);

        dispatch(stopUILoading());
    };
};
